import { useContext } from 'react';

import {
  CoursePagesContext,
  type ICoursePagesContextData,
} from '../contexts/coursePage';

export const useCoursePages = (): ICoursePagesContextData =>
  useContext(CoursePagesContext);
